import React, { useState, useEffect } from "react";
import axios from "axios";
import myConfig from "../../configs/config";
import MDSpinner from "react-md-spinner";
import { withTranslation } from "react-i18next";
import ExportButton from "../../components/Export_button";
import AddButton from "../../components/Add_button";
import { isChildrenEmpty, normalizeApiList } from "../../helpers/utils";
import { Link } from "react-router-dom";

import { FaEdit, FaTrashAlt } from "react-icons/fa";
import BackButton from "../../components/BackButton";
import DeleteConfirmModal from "../../components/DeleteConfirmModal";
import { usePendingMachineRegistration } from "../../contexts/PendingMachineRegistrationContext";
import {
  isPendingMachineRegistration,
  sortMachinesPendingFirst,
  visibleMachinesForWeb,
} from "./machineVisibility";
import { toast, ToastContainer } from "react-toastify";

function registrationBadge(machine, operatorName, t) {
  if (!isPendingMachineRegistration(machine)) {
    return null;
  }
  return (
    <span className="label label-warning" style={{ marginLeft: 8 }}>
      {t("Cadastro pendente")}
      {operatorName ? ` — ${t("operador")}: ${operatorName}` : ""}
    </span>
  );
}

function ListMachine(props) {
  const farmId = props.match.params.farm_id;
  const { refreshPendingRegistrations, pendingItems } =
    usePendingMachineRegistration();

  const [listMachines, setMachines] = useState([]);
  const visibleMachines = sortMachinesPendingFirst(
    visibleMachinesForWeb(listMachines)
  );
  const pendingMachines = visibleMachines.filter(isPendingMachineRegistration);
  const wantsPending =
    typeof window !== "undefined" &&
    /[?&]cadastro=pendente/.test(window.location.search);

  function operatorNameFor(machine) {
    if (machine.pending_operator_name) {
      return machine.pending_operator_name;
    }
    const match = (pendingItems || []).find(
      (item) =>
        String(item.id) === String(machine.id) ||
        String(item.ident) === String(machine.ident)
    );
    return (match && match.operatorName) || "";
  }
  const [loading, setLoding] = useState(true);
  const [loadError, setLoadError] = useState("");
  const [deleteCandidate, setDeleteCandidate] = useState(null);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    document.title = "Agriconnected - Máquinas";
    getMachines();
  }, []);

  async function getMachines() {
    setLoadError("");
    setLoding(true);
    try {
      let MACHINE_LIST_URL = `${myConfig.API_URL}/equipment/?farm_id=${farmId}`;

      const response = await axios({
        baseURL: MACHINE_LIST_URL,
        method: "get",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("client-token")}`,
        },
      });

      const data = normalizeApiList(response.data);
      setMachines(data);
      refreshPendingRegistrations();
    } catch (error) {
      const status = error.response && error.response.status;
      if (status === 401 || status === 403) {
        setLoadError(
          "Sua sessão expirou ou você não tem permissão. Faça login novamente."
        );
      } else {
        setLoadError(
          "Falha ao carregar máquinas. Verifique se a API está rodando e tente novamente."
        );
      }
    } finally {
      setLoding(false);
    }
  }

  function openDeleteConfirm(e, machine) {
    e.preventDefault();
    setDeleteCandidate(machine);
  }

  function closeDeleteConfirm() {
    if (deleting) return;
    setDeleteCandidate(null);
  }

  async function confirmDeleteMachine() {
    if (!deleteCandidate) return;

    const { id, ident } = deleteCandidate;
    setDeleting(true);
    try {
      await axios({
        baseURL: `${myConfig.API_URL}/equipment/${id}/`,
        method: "delete",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("client-token")}`,
        },
      });
      window.scrollTo(0, 0);
      setMachines((current) => current.filter((machine) => machine.id !== id));
      refreshPendingRegistrations();
      toast.success(
        props.t("Máquina {{ident}} excluída com sucesso.", { ident }),
        { position: "bottom-right", autoClose: 3000 }
      );
      setDeleteCandidate(null);
    } catch (error) {
      toast.error(
        props.t("Não foi possível excluir a máquina {{ident}}.", { ident }),
        { position: "bottom-right", autoClose: 5000 }
      );
    } finally {
      setDeleting(false);
    }
  }

  return (
    <>
      {loading === false ? (
        <div id="machine_list_container">
          <div className="x_title">
            <BackButton to={`/${farmId}`} label={props.t("Voltar")} />
            <h2>{props.t("Máquinas")}</h2>
            <div className="clearfix"></div>
          </div>

          <AddButton
            url={`/${farmId}/equipment/machine/add/`}
            classname="btn btn-primary btn-default-add"
          />
          <ExportButton
            classname="btn btn-default-export"
            export={`${myConfig.API_URL}/equipment/export_equipment/?farm_id=${farmId}`}
          />

          {loadError ? (
            <div className="alert alert-danger" role="alert">
              {loadError}
            </div>
          ) : null}

          {wantsPending || pendingMachines.length > 0 ? (
            <div className="alert alert-warning" role="status">
              {pendingMachines.length > 0
                ? props.t("{{count}} máquina(s) com cadastro pendente", {
                    count: pendingMachines.length,
                  })
                : props.t("Nenhuma máquina com cadastro pendente")}
            </div>
          ) : null}

          {isChildrenEmpty(
            visibleMachines,
            <h4 align="center">
              {props.t(
                "Está fazenda ainda não possui nenhuma máquina cadastrada."
              )}
            </h4>,
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>{props.t("Identificação")}</th>
                  <th>{props.t("Marca")}</th>
                  <th className="text-center"> {props.t("Ação")}</th>
                </tr>
              </thead>
              <tbody>
                {visibleMachines.map((machine) => (
                  <tr
                    key={machine.ident}
                    className={
                      isPendingMachineRegistration(machine) ? "warning" : ""
                    }
                  >
                    <td>
                      {machine.ident}
                      {registrationBadge(
                        machine,
                        operatorNameFor(machine),
                        props.t
                      )}
                    </td>
                    <td>{machine.marca}</td>
                    <td align="center">
                      <div className="btn-group">
                        <Link to={`${machine.id}/`} className="btn">
                          <FaEdit />
                        </Link>
                        <button
                          type="button"
                          onClick={(event) => openDeleteConfirm(event, machine)}
                          className="btn"
                          title={props.t("Excluir máquina")}
                          aria-label={props.t("Excluir máquina {{ident}}", {
                            ident: machine.ident,
                          })}
                        >
                          <FaTrashAlt />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          <DeleteConfirmModal
            open={Boolean(deleteCandidate)}
            title={props.t("Excluir máquina")}
            message={
              deleteCandidate
                ? props.t(
                    "Deseja realmente excluir a máquina {{ident}}? Esta ação remove o cadastro da máquina do banco de dados e não pode ser desfeita.",
                    { ident: deleteCandidate.ident }
                  )
                : ""
            }
            confirmLabel={props.t("Excluir máquina")}
            cancelLabel={props.t("Cancelar")}
            onConfirm={confirmDeleteMachine}
            onCancel={closeDeleteConfirm}
            loading={deleting}
          />
        </div>
      ) : (
        <div
          style={{ marginTop: "50px", marginLeft: "50%", minHeight: "200px" }}
        >
          <MDSpinner />
        </div>
      )}
      <ToastContainer position="bottom-right" />
    </>
  );
}

export default withTranslation()(ListMachine);
